/** Shared motion language — restrained, purposeful. (CO 069) */
export const fadeUp = {
    hidden: { opacity: 0, y: 16 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
    },
};
export const stagger = {
    hidden: {},
    show: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};
/** Default viewport trigger for scroll-reveal sections. */
export const inView = {
    initial: "hidden",
    whileInView: "show",
    viewport: { once: true, margin: "-80px" },
};
